import React from "react";

const blockTypes = [
  { type: "hero", label: "Hero Banner" },
  { type: "features", label: "Features" },
  { type: "section", label: "Section" },
  { type: "imageWithText", label: "Image + Text" },
  { type: "list", label: "List" },
  { type: "cards", label: "Cards" },
  { type: "cta", label: "Call To Action" },
  { type: "faq", label: "FAQ" },
  { type: "imageGallery", label: "Gallery" },
  { type: "contactForm", label: "Contact Form" },
];

export default function BlockPalette({ setBlocks }) {
  const addBlock = (type) => {
    setBlocks((prev) => [...prev, { type }]);
  };

  return (
    <div className="block-palette">
      <h3>Blocks</h3>

      {blockTypes.map((b) => (
        <button key={b.type} className="block-btn" onClick={() => addBlock(b.type)}>
          {b.label}
        </button>
      ))}
    </div>
  );
}
